import {
  FC,
  useState,
  useEffect,
  createContext,
  useContext,
  useRef,
  Dispatch,
  SetStateAction,
} from 'react'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import {AuthModel, UserModel} from './_models'
import * as authHelper from './AuthHelpers'
import {verifyToken, logoutAndBlacklist} from './_requests'
import {WithChildren} from '../../../../_metronic/helpers'
import jwtDecode from 'jwt-decode'

type AuthContextProps = {
  auth: AuthModel | undefined
  saveAuth: (auth: AuthModel | undefined) => void
  currentUser: UserModel | undefined
  setCurrentUser: Dispatch<SetStateAction<UserModel | undefined>>
  logout: () => void
}

const initAuthContextPropsState = {
  auth: authHelper.getAuthJWT(),
  saveAuth: () => {},
  currentUser: undefined,
  setCurrentUser: () => {},
  logout: () => {},
}

const AuthContext = createContext<AuthContextProps>(initAuthContextPropsState)

const useAuth = () => {
  return useContext(AuthContext)
}

const AuthProvider: FC<WithChildren> = ({children}) => {
  const [auth, setAuth] = useState<AuthModel | undefined>(authHelper.getAuthJWT())
  const [currentUser, setCurrentUser] = useState<UserModel | undefined>()
  const saveAuth = (auth: AuthModel | undefined) => {
    setAuth(auth)
    if (auth) {
      console.log('AuthProvider')
      authHelper.setAuthJWT(auth)
      console.log('AuthProvider: setAuthJWT(auth) succesfull')
      console.log(auth)

    } else {
      console.log('AuthProvider: removeAuthJWT()')
      authHelper.removeAuthJWT()
    }
  }

  const logout = async () => {
    console.log('AuthProvider: logout()')

    // Try to blacklist the refresh token on the server
    const refreshToken = authHelper.getRefreshToken()
    if (refreshToken) {
      try {
        await logoutAndBlacklist(refreshToken)
        console.log('AuthProvider: refresh token blacklisted successfully')
      } catch (error) {
        // Continue with logout even if blacklist fails (token might be expired)
        console.log('AuthProvider: failed to blacklist refresh token (continuing logout)', error)
      }
    }

    saveAuth(undefined)
    setCurrentUser(undefined)
  }

  return (
    <AuthContext.Provider value={{auth, saveAuth, currentUser, setCurrentUser, logout}}>
      {children}
    </AuthContext.Provider> 
  )
}

const AuthInit: FC<WithChildren> = ({children}) => {
  const {auth, logout, setCurrentUser} = useAuth()
  const didRequest = useRef(false)
  const [showSplashScreen, setShowSplashScreen] = useState(true)
  // We should request user by authToken (IN OUR EXAMPLE IT'S API_TOKEN) before rendering the application
  useEffect(() => {
    const requestUser = async (acceskey: string) => {
      try {
        if (!didRequest.current) {

          // JK: Here we need to get the userModel from the accesskey
          const data: UserModel = jwtDecode(acceskey) 
  
          // JK: Just make a call to check that the token is still valid. If not, we'll logout in the catch.
          const response = await verifyToken(acceskey)

          if (data) {
            setCurrentUser(data)
          }
        }
      } catch (error) {
        console.error(error)
        if (!didRequest.current) {
          logout()
        }
      } finally {
        setShowSplashScreen(false)
      }

      return () => (didRequest.current = true)
    }
 

    if (auth && auth.access) {
      requestUser(auth.access)
    } else {
      logout()
      setShowSplashScreen(false)
    }
    // eslint-disable-next-line
  }, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{children}</>
}

export {AuthProvider, AuthInit, useAuth}
